import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PipeFotoPipe } from '../pipes/pipe-foto.pipe';
import { DaoService } from '../servicos/dao.service';

@Component({
  selector: 'app-view-pessoa',
  templateUrl: './view-pessoa.component.html',
  styleUrls: ['./view-pessoa.component.css']
})
export class ViewPessoaComponent implements OnInit {

  constructor(private route: ActivatedRoute, public dao:DaoService) { }
  private subs:any;
  id:any;
  grupo:any;
  detalhe:any;
  pipeFoto = new PipeFotoPipe();
  ngOnInit() {
    this.subs = this.route.params.subscribe(params => {
      this.id = params['id']; // (+) converts string 'id' to a number
      this.grupo = params['grupo'];
      this.detalhe = params['detalhe'];
      this.carregar();
   });
  }

  enviarEmail(email){
    window.location.assign(`mailto:${email}`);
  }

  pessoas:any;
  carregar(){
    let dados = {grupo:this.grupo, id:this.id, detalhe:this.detalhe};

    this.dao.submeter(dados,"listarPorGrupo").then(res=>{
      res.forEach(p=>{
        let ti = '';
        ti+='<div style="font-size:11px;text-align:center">'+p.nome+'</div>';
        ti+='<div style="font-size:11px;text-align:center">'+p.funcao+'</div>';
        ti+= '<div style="font-size:10px;text-align:center">'+p.email+'</a></div>';
        ti+= '<div style="text-align:center"><img src="'+this.pipeFoto.transform(p.foto)+'" style="width:75px;heigth:75px"></div>';
        ti+='<div style="font-size:11px;text-align:center">Origem: '+p.origem+'</div>';
        
        p.tip = ti;
      });
      this.pessoas = res;

      console.log("Pessoas",this.pessoas);
    });
    // carregar pessoa
    // grupo 
    // com ou sem detalhes
  }

}
